import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, VAULT_PATH } from "@/lib/api";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import Seo from "@/components/site/Seo";

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/auth/login", { password });
      navigate(VAULT_PATH, { replace: true });
    } catch (err) {
      const msg = err?.response?.data?.detail || err?.message || "Login failed";
      setError(typeof msg === "string" ? msg : "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="bg-white text-[#0a0a0a] min-h-screen flex flex-col">
      <Seo title="Vault — Universtrend" description="Restricted." />
      <Header />
      <main className="flex-1 flex items-center justify-center px-6 py-16">
        <form
          onSubmit={submit}
          className="w-full max-w-md border border-black p-8 lg:p-10"
          data-testid="admin-login-form"
        >
          <div className="overline text-[#52525b] mb-3">Restricted area</div>
          <h1 className="font-display font-extrabold text-4xl lg:text-5xl tracking-tighter leading-[0.95]">
            The Vault.
          </h1>
          <p className="text-sm text-[#52525b] mt-3">
            Owner-only. Enter your password to continue.
          </p>

          <label className="overline block mt-8 mb-2">Password</label>
          <input
            data-testid="admin-password-input"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
            className="w-full border border-black px-4 py-3 font-mono text-sm focus:outline-none"
            placeholder="••••••••"
          />

          {error && (
            <div
              data-testid="admin-login-error"
              className="mt-4 border border-[#ff3b30] bg-[#fff5f5] px-3 py-2 font-mono text-xs text-[#ff3b30]"
            >
              {error}
            </div>
          )}

          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={busy}
            className="mt-6 w-full bg-black text-white py-3 overline hover:bg-[#ff3b30] transition-colors disabled:opacity-50"
          >
            {busy ? "Verifying…" : "Unlock →"}
          </button>
          <p className="font-mono text-[10px] text-[#52525b] mt-4">
            5 failed attempts locks this IP for 15 minutes.
          </p>
        </form>
      </main>
      <Footer />
    </div>
  );
}
